// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { secondaryNavigationStyles } from "@ces/Overrides/Widgets/Header/SecondaryNavigation";
import { color, layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import { css } from "styled-components";

secondaryNavigationStyles.container = {
    css: css`
        background: ${color("common.ui12")};
        padding: 8px 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

secondaryNavigationStyles.wrapper = {
    css: css`
        ${layoutContainer}
        display: flex;
        justify-content: space-between;
        padding: 0;
        align-items: center;
    `,
};

secondaryNavigationStyles.rightSide = {
    css: css`
        p {
            margin-bottom: 0;
            font-size: 12px;
            line-height: 13px;
            color: ${color("common.white")};
        }
        ${ContentWrapper} {
            display: flex;
            align-items: center;
        }
    `,
};

secondaryNavigationStyles.links = {
    css: css`
        display: flex;
        align-items: center;
        gap: 32px;
    `,
};
